<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    popupshow: false,
    deskList: [],
    selectedDesk: '_FF00321822120916460149925921541158_',
    viewPortId: '',
    selectedCRMTemplate: '',
    crmList: []
  }),
  created() {

  },
  mounted() {
  },
  computed:{
  },
  methods: {
    getCrmInfo : function(viewport) {
      let bpmnComponentTipId = '_FF00321822120916427824957001562784_';

      var client = window.botStore.getClientByViewPort(viewport);
      console.log("main home page client",client);

      let GrantPath = JSON.parse(client.ClientContext);
      let GrantPE = GrantPath.GrantPE;
      let currentContext = JSON.parse(client.CurrentContext);
      let requestContext = currentContext;

      let params = {
         componentId : bpmnComponentTipId,
         command : "getCrmList",
         data : requestContext,
         Type : 'BotApi'
       };
       this.crmList =[];
       let defaultcrmVal = {};
       defaultcrmVal.value = "_FFFFFFFFFFFFFF00001668203009117626_";
       defaultcrmVal.text =  "Simplia CRM";
       this.crmList.push(defaultcrmVal);
       let defaultcrmVal1 = {};
       defaultcrmVal1.value = "_FFFFFFFFFFFFFF00001632605739322815_";
       defaultcrmVal1.text =  "Provider CRM";
       this.crmList.push(defaultcrmVal1);
       

       window.BotServices.callComponent(params, (err, result) => {
         if(result) {
           console.log("===result crmList getComponents===",result);
           result.forEach((crm) => {
               let crmVal = {};
               crmVal.value = crm.GrantRightID;
               crmVal.text =  crm.GrantRightDN;
               this.crmList.push(crmVal);
           });
           console.log("crmList",this.crmList);
         }
       });
    },
    getDeskInfo : function(viewport) {
      let bpmnComponentTipId = '_FF00321822120916427824957001562784_';

      var client = window.botStore.getClientByViewPort(viewport);
      console.log("main home page client",client);

      let GrantPath = JSON.parse(client.ClientContext);
      let GrantPE = GrantPath.GrantPE;
      let currentContext = JSON.parse(client.CurrentContext);
      let requestContext = currentContext;

      let params = {
         componentId : bpmnComponentTipId,
         command : "getDeskList",
         data : requestContext,
         Type : 'BotApi'
       };
       this.deskList =[];
       let defaultdeskVal = {};
       defaultdeskVal.value = "_FF00321822120916460149925921541158_";
       defaultdeskVal.text =  "Simplia Desk";
       this.deskList.push(defaultdeskVal);

       window.BotServices.callComponent(params, (err, result) => {
         if(result) {
           console.log("===result deskList getComponents===",result);
           result.forEach((desk) => {
               let deskVal = {};
               deskVal.value = desk.ProcessTemplateID;
               deskVal.text =  desk.ProcessTemplateDN;
               this.deskList.push(deskVal);
           });
         }
       });
    },
    showDeskPanel: function(viewport) {
      console.log("got desk name",this.selectedDesk,"====",this.selectedCRMTemplate);
    //  window.DevMgr.setMeeting(document.getElementById('meetingName').value);
        this.popupshow = false;
        let store = window.devStore;
        var clientObj = window.botStore.getClientByViewPort(viewport);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        console.log("main home page client",clientObj);

        /*let parentIndex = store.getMeetingIndex(clientObj.RootMeeting);
        let localIndex = store.getMeetingIndex(clientObj.Meeting);

        let rootMenuObj = {
          ParentIndex : localIndex,
          LocalIndex : localIndex,
          PrettyURL : null,
          Path : clientObj.RootMeeting+'/Desk',
          LeftRole : clientObj.ClientLeftRole,
          RightRole : clientObj.ClientRightRole,
          LeftID : clientObj.ClientLeft,
          RightID : clientObj.ClientRight,
          LeftDN : clientObj.ClientRightDN,
          RightDN : 'Desk',
          DisplayStatus : null,
          ClientRowID : clientObj.Client
        };

        store.addRootMenu(rootMenuObj);

        console.log("PullRootMenu currentContext : ", currentContext);
        let paramObj = "ProcessTemplateID="+this.selectedDesk+"&CrmTemplateID="+this.selectedCRMTemplate;
        console.log("select desk params",paramObj);
        if(clientObj.ClientRight == '_FFFFFFFFFFFFFF00001665780556359109_') {
           rootMenuObj.Termination = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/LetoCRM/home.html?"+paramObj};
        } else if(this.selectedDesk == "_FF00321822120916460149925921541158_" && this.selectedCRMTemplate == "_FFFFFFFFFFFFFF00001668203009117626_") {
            rootMenuObj.Termination = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/SimpliaDesk/Desk.html?"+paramObj};
        } else {
            rootMenuObj.Termination = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/SimpliaDesk/Desk.html?"+paramObj};
        }*/

          console.log("PullRootMenu currentContext : ", currentContext);let terminationUrl = "";
          let paramObj = "ProcessTemplateID="+this.selectedDesk+"&CrmTemplateID="+this.selectedCRMTemplate;
          console.log("select desk params",paramObj);

          if(clientObj.ClientRight == '_FFFFFFFFFFFFFF00001665780556359109_') {
              terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/LetoCRM/home.html?"+paramObj};
          } else if(this.selectedDesk == "_FF00321822120916460149925921541158_" && this.selectedCRMTemplate == "_FFFFFFFFFFFFFF00001668203009117626_") {
              terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/FollowupV2/FollowupV2.html?"+paramObj};
          } else {
              terminationUrl = {"MediaType":"Iframe","URL":"/DeepLander-0086/CRMV2/FollowupV2/FollowupV2.html?"+paramObj};
          }
          window.BotServices.openChildPanel({ClientID : clientObj.Client, DisplayName : 'Followup', Termination : terminationUrl}, ()=>{});
        /*window.BotServices.PullRootMenu(rootMenuObj);*/
    },
    showPopUp : function(popObj) {
      console.log("====show pop up====",popObj);
      this.viewPortId = popObj.viewport;
      this.popupshow = true;
      this.getDeskInfo(popObj.viewport);
      this.getCrmInfo(popObj.viewport);
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="popupshow" >
  <template v-slot:title>Select Template</template>
  <template v-slot:content>
  <form class="formbox" >
    <div class="form-group" style="display:none;margin-top:5px;">
      <span class="label-text">Desk Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <select name="deskName" id="deskName" class="form-dropdown" v-model="selectedDesk">
          <option value="" disabled>Select Desk</option>
          <option v-for="desk in deskList" v-bind:value=desk.value>{{ desk.text }}</option>
      </select>
    </div>

      <div class="form-group" style="display:flex;margin-top:5px;">
        <span class="label-text">Subject Template</span>
        <select name="subjectTemplate" id="subjectTemplate" class="form-dropdown" v-model="selectedCRMTemplate">
            <option value="">Select Template</option>
            <option v-for="crm in crmList" v-bind:value=crm.value>{{ crm.text }}</option>
        </select>
      </div>
  </form>
  </template>
  <template v-slot:action>
     <button id="btn-submit" type="button" class="ButtonText" @click="showDeskPanel(viewPortId)">Submit</button>
  </template>
</Popup>
</template>

<style>
.form-dropdown {
    display: block;
    width: 100%;
    padding: 0.175rem 0.15rem;
    font-size: 1rem;
    line-height: 1.0;
    color: #495057;
    background-color: #fff;
    background-image: none;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.label-text {
    padding: 0 50px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:100%;
}

formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
</style>
